import { bytesToBase64 } from 'byte-base64'

export default function (value: number): string {
  return bytesToBase64(new Uint8Array([
    (value & 0x00000000000000ff),
    (value & 0x000000000000ff00) >> 8,
    (value & 0x0000000000ff0000) >> 16,
    (value & 0x00000000ff000000) >> 24,
    (value & 0x000000ff00000000) >> 32,
    (value & 0x0000ff0000000000) >> 40,
    (value & 0x00ff000000000000) >> 48,
    (value & 0xff00000000000000) >> 56
 ]))
}
